






































































































































































































import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { ProductPayload } from "@/models/Product";
import { camelToUnderscore, startsWithVowel } from "@/utils/Typography";
import VCheckbox from "@/components/VCheckbox.vue";

import {
  CatalogueSetting,
  catalogueSettings,
  generalSettings,
  SettingEntry,
} from "../../models/Setting";
import WithErrors from "@/directives/WithErrors";
import SectionField from "@/components/SectionField.vue";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VEntrySearch from "@/components/VEntrySearch.vue";
import CatalogueSettingsSelect from "@/components/CatalogueSettings/Select.vue";
import GeneralSettingsSelect from "@/components/GeneralSettings/Select.vue";
import PageSection from "@/components/PageSection.vue";
import FileUploader from "@/components/FileUploader.vue";
import VMultiTuple from "@/components/VMultiTuple.vue";
import BlueprintSelect from "@/components/Blueprint/Select.vue";
import Page from "@/views/Page.vue";
import Tuple from "@/models/Tuple";

@Component({
  directives: {
    WithErrors,
  },
  components: {
    GeneralSettingsSelect,
    BlueprintSelect,
    VCurrencyInput,
    VCheckbox,
    PageSection,
    FileUploader,
    VEntrySearch,
    CatalogueSettingsSelect,
    Page,
    SectionField,
    VMultiTuple,
  },
})
export default class ProductForm extends Vue {
  @Prop({ default: null }) readonly product!: ProductPayload | null;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly requestTag!: string;
  @Prop({ default: false }) readonly loading!: boolean;

  @Ref() readonly upload;

  private blueprint = null;

  formData: ProductPayload = this.product ? { ...this.product } : null;

  private offsets: Tuple[] = [];
  private scalings: Tuple[] = [];

  @Watch("product", { deep: true })
  onProductChanged() {
    this.formData = this.product
      ? JSON.parse(JSON.stringify(this.product))
      : null;

    this.convertMetadataVectors();
  }

  get selectedBlueprint() {
    return this.formData.blueprint_id;
  }

  private vectorToTuple(field: string): Tuple[] {
    if (!this.formData.metadata[field]) {
      return [];
    }

    return this.formData.metadata[field].map((el: any) => el);
  }

  onBlueprintSelected(id) {
    this.formData.blueprint_id = id;
  }

  private convertMetadataVectors() {
    if (!this.formData?.metadata) {
      return;
    }

    this.offsets = [...this.vectorToTuple("offsets")];
    this.scalings = [...this.vectorToTuple("scalings")];
  }

  @Watch("offsets", { deep: true })
  onOffsetsChange() {
    const vectors = this.offsets.map((direction: Tuple) => {
      return {
        x: parseFloat(direction.x),
        y: parseFloat(direction.y),
        z: parseFloat(direction.z),
      };
    });
    this.formData.metadata.offsets = vectors;
  }

  @Watch("scalings", { deep: true })
  onScalingsChange() {
    const vectors = this.scalings.map((direction: Tuple) => {
      return {
        x: parseFloat(direction.x),
        y: parseFloat(direction.y),
        z: parseFloat(direction.z),
      };
    });
    this.formData.metadata.scalings = vectors;
  }

  openFiles() {
    const file = (this.$refs.upload as any).openFileBrowser();
  }

  underscorize(entry: SettingEntry) {
    if (entry.type !== "catalogueAttributes") {
      return camelToUnderscore(entry.singularType).replace("catalogue_", "");
    }
    return camelToUnderscore(entry.singularType);
  }

  placeholder(setting: SettingEntry) {
    const article = startsWithVowel(setting.singularName) ? "an" : "a";
    return `Select ${article} ${setting.singularName.toLowerCase()}`;
  }

  searchable(type) {
    return !!this.searchableItems.find((o) => o.type === type);
  }

  onCatalogueSettingChanged(rawKey, value) {
    const key = CatalogueSetting.attributeKey(rawKey);
    if (key === "material_id") {
      this.formData.rating_id = null;
    }
    this.formData[key] = value;
  }

  onGeneralSettingChanged(rawKey, value) {
    let key = camelToUnderscore(rawKey);
    key += `_id`;
    this.formData[key] = value;
  }

  selected(rawKey: string) {
    const key = CatalogueSetting.attributeKey(rawKey);
    return this.product[key];
  }

  get ratingFilter() {
    const data: { material?: string | number } = {};
    if (!this.formData) {
      return {};
    }
    if (this.formData.material_id) {
      data.material = this.formData.material_id;
    }
    return data;
  }

  get catalogueSelects() {
    return catalogueSettings.filter(
      (o) =>
        o.type !== "catalogueCapacities" &&
        o.type !== "catalogueRatings" &&
        o.type !== "catalogueMaterials"
    );
  }

  get isBuswayKind() {
    return (
      this.product?.typologyKind === "busway" ||
      this.product?.typologyKind === "distribution_busway"
    );
  }

  get isTerminalKind() {
    return (
      this.product?.typologyKind === "terminal" ||
      this.product?.typologyKind === "reducer_joint"
    );
  }

  get materialSelect() {
    return [catalogueSettings.find((o) => o.type === "catalogueMaterials")];
  }
  get ratingSelect() {
    return [catalogueSettings.find((o) => o.type === "catalogueRatings")];
  }

  get searchableItems() {
    return this.catalogueSelects.filter(
      (o) => o.type === "catalogueTypologies"
    );
  }

  get generalSelects() {
    return generalSettings.filter((o) => o.type === "measurementUnits");
  }
}
